import React from 'react';
import '../css/main.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams
} from "react-router-dom";
import { DarkModeSwitch } from 'react-toggle-dark-mode';

import {signOut} from "../redux/action/authAction";
import {connect} from "react-redux"


function resposivefun() {
  var x = document.getElementById("selecter");
  if (x.className === "selecter"){
    x.className += " resposive";
  } else {
    x.className = "selecter";
  }
}

function closeNav(){
  var x = document.getElementById("selecter");
  x.className = "selecter";
  console.log("hi")
  
}

const Navbar = ({signOut, uid}) => {
  const [isDarkMode, setDarkMode] = React.useState(true);

  const toggleDarkMode = (checked) => {
    setDarkMode(!checked);
    document.body.classList.toggle(document.body.className === 'light' ? 'dark': 'light')
  };

  return (
    <div>
<div className="navbar" id="navbar">
  <ul className="selecter" id="selecter">
    <Link to="/home" onClick={() => closeNav()} style={{textDecoration: 'none'}}><li><i className="fas fa-home"></i>Home</li></Link>
    {/* <li><i className="far fa-file-alt"></i> <a href="/files">PDF Files - ملفات</a></li> */}
    <Link to="/blogs" onClick={() => closeNav()} style={{textDecoration: 'none'}}><li><i className="fas fa-book" onClick={() => closeNav()}></i> Blogs</li></Link>
     {/* <li><i className="far fa-file-alt"></i> <a onclick="PdfPage()">PDF Files - ملفات البي دي اف</a></li> */}
    {/* <li><i className="far fa-question-circle"></i> <a href="/ask">Ask Me - أسالني</a></li> */}
    <Link to="/works" onClick={() => closeNav()} style={{textDecoration: 'none'}}><li><i className="fas fa-wrench" onClick={() => closeNav()}></i> My Works</li></Link>
    <Link to="/tutorial" onClick={() => closeNav()} style={{textDecoration: 'none'}}><li><i className="fa fa-play" onClick={() => closeNav()}></i> Tutorials</li></Link>
    {/* <Link to="/people" onClick={() => closeNav()} style={{textDecoration: 'none'}}><li><i className="fa fa-users" onClick={() => closeNav()}></i> People I know</li></Link> */}

{/*     <Link to="/cv" onClick={() => closeNav()} style={{textDecoration: 'none'}}><li><i className="far fa-address-card" onClick={() => closeNav()}></i>[ CV ] About Me - عني</li></Link>
 */}    <li>
    {uid && <button onClick={signOut}>Signout</button>} 

    </li>
    <li>
      <DarkModeSwitch
        style={{ color: 'whitesmoke' }}
        checked={isDarkMode}
        onChange={toggleDarkMode}
        size={30}
      />
    </li>


    <div className="Name-tag"></div>
    <a href="javascript:void(0);" className="icon" onClick={() => resposivefun()}>
    <i className="fa fa-bars"></i></a>
  </ul>
</div>
    <div style={{backgroundColor: '#2e2d2d', height: '5px'}}></div>
    </div>
  )
}

const mapStateToProps = state => {
  const uid = state.firebase.auth.uid 

  return {
    uid: uid
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut())

  }
}
export default connect(mapStateToProps,mapDispatchToProps) (Navbar);
